<template>
  <div class="filter">
    <div class="filter-title">
      <Skeleton height="20px" width="64px" borderRadius="4px" />
    </div>
    <div class="filter-content">
      <div class="filter-content-box" v-for="i in 2" :key="i">
        <div class="skeleton-title">
        <Skeleton height="18px" width="75px" borderRadius="4px" />
        <Skeleton height="40px" width="100%" borderRadius="4px" />
        </div>
        <div class="skeleton-container">
          <Skeleton  height="20px" width="20px" borderRadius="4px" />
          <Skeleton  height="18px" width="120px" borderRadius="4px" />
        </div>
        <div class="skeleton-container">
          <Skeleton  height="20px" width="20px" borderRadius="4px" />
          <Skeleton  height="18px" width="60px" borderRadius="4px" />
        </div>
        <div class="skeleton-container">
          <Skeleton  height="20px" width="20px" borderRadius="4px" />
          <Skeleton  height="18px" width="100px" borderRadius="4px" />
        </div>
        <div class="skeleton-container">
          <Skeleton  height="20px" width="20px" borderRadius="4px" />
          <Skeleton  height="18px" width="120px" borderRadius="4px" />
        </div>
        <div class="skeleton-container">
          <Skeleton  height="20px" width="20px" borderRadius="4px" />
          <Skeleton  height="18px" width="60px" borderRadius="4px" />
        </div>
        <div class="skeleton-container">
          <Skeleton  height="20px" width="20px" borderRadius="4px" />
          <Skeleton  height="18px" width="100px" borderRadius="4px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Skeleton } from '@n11/so-ui-components';

export default {
  name: "Filter",
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.skeleton-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.skeleton-title {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.filter-content-box {
  margin-bottom: 16px;
}
</style>
